var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "375px",
    width: "400px",
    viewBox: "0 0 1170 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "scale(1,-1) translate(0,-650)",
    horizAdvX: 1164,
    d: "M870 867l14-5q14-17 25-38t22-46l70-204 23-70v-265l-56-47q-17-10-40-16.5t-44-6.5h-605q-21 0-41 6.5t-38 16.5l-60 51v261l23 70 70 204q10 21 21 41.5t25 38.5l14 9h577zM884 960h-605q-14-3-30-9.5t-30-13.5q-21-28-38.5-59t-31.5-62q-7-18-14-37.5t-14-37.5h-51q-28 0-49-21t-21-49 21-46.5 49-18.5v0 0h4l-27-84v-539q7-18 18-29t28-18h233q17 7 28 20.5t18 30.5v89h419v-89q7-17 18-30.5t29-20.5h233q17 7 28 18t18 29v539l-28 84h5q28 0 49 18.5t21 46.5v0 0q0 28-21 49t-49 21h-51q-7 18-14 37.5t-14 37.5q-14 31-31.5 62t-38.5 59q-14 7-30.5 13.5t-30.5 9.5v0 0zM884 29v47q39 0 74 11t66 35v-93h-140zM140 29v93q31-24 66-35t73-11v-47h-139zM349 495q-28 0-49-21t-21-49 21-49 49-21 49 21 21 49-21 49-49 21v0 0zM815 495q-28 0-49-21t-21-49 21-49 49-21q27 0 48 21t21 49-19 49-50 21v0 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHCar);
export default __webpack_public_path__ + "static/media/h-car.36cf4c261b779bfcfd8380c38b9e8966.svg";
export { ForwardRef as ReactComponent };